import 'ag-grid-enterprise';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { logger } from './services/logger/logger';
import './i18n';

// -> Routing
import { BrowserRouter } from 'react-router-dom';

//-> Store
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store';

//-> MSAL Library for authentication
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './config/msalConfig';

ModuleRegistry.registerModules([AllEnterpriseModule]);

//-> License key for ag grid
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY as string);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => {
  logger.info('Web Vitals metric', metric);
});
